import Link from 'next/link';
import { Icon } from 'core/generic/elements/icons';

import { PUBLIC_BASE_URL_ENV } from 'tools/environments';

import styles from './search-icon.module.scss';

export const SearchIcon = () => (
    <Link
        href={`${PUBLIC_BASE_URL_ENV}/search`}
        className={styles['search']}
        aria-label="Go to Search page"
        data-testid="search-icon-link"
    >
        <Icon variant="Search" className={styles['search-icon']} />
    </Link>
);
